/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * El curriculum admite incluir dos enlaces a perfiles de redes sociales (Linkedin y InfoJobs) [P_A_23]
 * @export
 * @interface CandidateLink
 */
export interface CandidateLink {
    /**
     * 
     * @type {number}
     * @memberof CandidateLink
     */
    id?: number;
    /**
     * infojobs, linkedin
     * @type {string}
     * @memberof CandidateLink
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidateLink
     */
    url?: string;
}

export function CandidateLinkFromJSON(json: any): CandidateLink {
    return CandidateLinkFromJSONTyped(json, false);
}

export function CandidateLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): CandidateLink {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function CandidateLinkToJSON(value?: CandidateLink | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'code': value.code,
        'url': value.url,
    };
}


